<template>
  <div class="body">
    <!-- <div class="van-clearfix">
      <ul v-if="goodsList.length">
        <li
          v-for="(item, index) in goodsList"
          :key="index"
          class="goods-list"
          :class="goodsList.length == 1 ? 'noMargin noRadiuShadow' : ''"
        >
          <div class="shopDetail">
            <img
              v-if="item.sellerLogo"
              :src="baseImg + item.sellerLogo"
              class="shopLogo"
            />
            <img
              v-else
              src="@/assets/img/iv_placeholder_Center@2x.png"
              class="shopLogo"
            />{{ item.sellerName }}
          </div>
          <div v-for="(itemWrap, indexWrap) in item.items" :key="indexWrap">
            <div class="commonPro">
              <div class="common_proImg">
                <img :src="baseImg + itemWrap.thumbnail" alt="" />
              </div>
              <div class="common_detail">
                <div class="common_pro_name">{{ itemWrap.goodsName }}</div>
                <div class="common_pro_detail">
                  <div class="common_pro_sku"></div>
                </div>
                <div class="pro_priceNum">
                  <div class="pro_value">
                    <span class="pro_unit">￥</span
                    ><span>{{ itemWrap.integerPrice }}</span
                    ><span class="pro_decimals"
                      >.{{ itemWrap.decimalsPrice }}</span
                    >
                  </div>
                  <div class="flexCenter">
                    <img
                      src="@/assets/img/icon_minus.png"
                      alt=""
                      class="icon_minus"
                      @click="accelerate(1, itemWrap)"
                    />
                    <input
                      type="number"
                      class="pro_num_input"
                      :value="itemWrap.quantity"
                      @input="inputLength"
                    />
                    <img
                      src="@/assets/img/icon_add.png"
                      alt=""
                      class="icon_minus"
                      @click="accelerate(2, itemWrap)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="goods-list-static"
        :class="goodsList.length == 1 ? 'noRadiu' : ''"
      >
        <div class="boxPart">
          <div>商品金额</div>
          <div>￥{{ sum }}</div>
        </div>
        <div class="allBox">
          <span class="" style="margin-right: 10px">共{{ sumGoodsNum }}件</span>
          <span class="">合计：</span><span class="money">￥{{ sum }}</span>
        </div>
      </div>
    </div> -->
    <div class="Box">
      <div class="box border2">
        <span class="slh">{{ projectDetail.name }}</span
        ><span class="blackSpan">￥{{ projectDetail.price }}</span>
      </div>
      <div class="box border2 paddingRight0">
        <span>数量</span>
        <div class="flexCenter">
          <img
            src="@/assets/img/icon_minus.png"
            alt=""
            class="icon_minus"
            @click="accelerate(1)"
          />
          <input
            v-model="number"
            type="number"
            class="pro_num_input"
            @input="inputLength"
            @blur="blurInput"
          />
          <img
            src="@/assets/img/icon_add.png"
            alt=""
            class="icon_minus"
            @click="accelerate(2)"
          />
        </div>
      </div>
      <div class="box border2">
        <span>小计</span
        ><span class="yellowSpan">￥{{ projectDetail.price }}</span>
      </div>
      <div class="box border8">
        <span>订单总价</span><span class="yellowSpan">￥{{ sum }}</span>
      </div>
      <div class="bottomBox">
        <span>购买须知</span>
        <p>
          · 预约须知：请您{{ projectDetail.appointmentRemark }}<br />
          · 退款规则：随时退、过期退<br />
          · 为保护未成年人健康成长，未成年用户请到监护人知悉同意后在<br />
          进行购买和体验，请勿购买不适合自身年龄段的产品
        </p>
      </div>
    </div>
    <div class="van-clearfix payWay" v-if="!isWx">
      <div class="ways" @click="chooseWays(1)">
        <div class="flexCenter">
          <img src="@/assets/img/alipay.png" alt="" class="wayIcon" />
          支付宝
        </div>
        <div class="select-box">
          <img src="@/assets/img/chooseArrow.png" v-if="payWays == 1" />
        </div>
      </div>
      <div class="ways" @click="chooseWays(2)" style="border: none">
        <div class="flexCenter">
          <img src="@/assets/img/weChat.png" alt="" class="wayIcon" />
          微信
        </div>
        <div class="select-box">
          <img src="@/assets/img/chooseArrow.png" v-if="payWays == 2" />
        </div>
      </div>
    </div>
    <div class="comm_f_box height120">
      <div class="price">
        <div class="pro_value">
          <span class="pro_unit">￥</span><span>{{ sum }}</span>
        </div>
      </div>
      <div class="btn" @click.stop="linkPay">立即支付</div>
    </div>
    <van-popup v-model="show" position="bottom">
      <div class="popTitle">商品清单</div>
      <ul class="van-clearfix pro_list">
        <li v-for="(item, index) in goodsListMore" :key="index">
          <div class="commonPro paddingBorder">
            <!-- 单个商品 -->
            <div class="common_proImg">
              <img src="@/assets/img/proDetail.jpg" alt="" />
            </div>
            <div class="common_detail">
              <div class="common_pro_name">{{ item.name }}</div>
              <div class="common_pro_detail">
                <div class="common_pro_sku">
                  {{ item.sku }}
                </div>
              </div>
              <div class="pro_priceNum">
                <div class="pro_value">
                  <span class="pro_unit">￥</span
                  ><span>{{ item.integerPrice }}</span
                  ><span class="pro_decimals">.{{ item.decimalsPrice }}</span>
                </div>
                <div class="flexCenter">
                  <img
                    src="@/assets/img/icon_minus.png"
                    alt=""
                    class="icon_minus"
                    @click="accelerate(1, item)"
                  />
                  <input
                    type="number"
                    class="pro_num_input"
                    :value="item.quantity"
                    @input="inputLength"
                    @blur="blurInput"
                  />
                  <img
                    src="@/assets/img/icon_add.png"
                    alt=""
                    class="icon_minus"
                    @click="accelerate(2, item)"
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
import EnvionmentVariables from "../../../../baseUrl";
import {
  formatPrice,
  linkApp,
  browserEnvironment,
  isWeixin,
} from "utils/index";
import { getToken, getOpenId } from "utils/auth";
import eventBus from "../../../utils/eventBus";
import Cookies from "js-cookie";
const wx = require("weixin-js-sdk");
export default {
  name: "shopCart",
  components: {},
  data() {
    return {
      baseImg: EnvionmentVariables.IMAGE_HOST,
      goodsList: [],
      goodsListMore: [
        {
          name: "老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用",
          sku: "老人款老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用",
          price: 139,
          num: 1,
          shopName: "携康自营店",
          integerPrice: 199,
          decimalsPrice: 99,
          isOneMore: 1, // 单个商品
        },
        {
          name: "老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用",
          sku: "老人款老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用老年手表 摔倒报警 好用",
          price: 139,
          num: 1,
          shopName: "携康自营店",
          integerPrice: 199,
          decimalsPrice: 99,
          isOneMore: 1, // 单个商品
        },
      ],
      payWays: 1,
      show: false,
      isHasAddress: 1,
      defaultAddressInfo: {
        id: "",
        isDefault: "",
        province: "",
        city: "",
        district: "",
        detailAddress: "",
        consigneeName: "",
        consigneeMobile: "",
      },
      sum: 0,
      sumGoodsNum: 0,
      sumIntegerPrice: 0,
      sumDecimalsPrice: 0,
      cartItemIds: [],
      addressId: "",
      isWx: isWeixin(),
      openId: "",

      projectDetail: {},
      clubDetail: {},
      number: 1,
      status: undefined,
      id: undefined,
      businessId:undefined
    };
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f7f5f5;");
    document.title = "填写订单";
  },
  created() {
    var that = this;
    console.log(11111);
    this.id = this.$route.query.id;
    this.status=this.$route.query.status;
    this.getClubProductDetailById();
    this.from = this.$route.query.from;
    // this.projectDetail = JSON.parse(localStorage.getItem('projectDetail'))
    this.clubDetail = JSON.parse(localStorage.getItem("clubDetail"));
    if(this.clubDetail){
      this.businessId=this.clubDetail.id
    }
    if(this.$route.query.businessId){
      this.businessId=this.$route.query.businessId
    }

    this.$forceUpdate();
    if (this.status == 1) {
      this.$toast("您已取消支付");
    }
  },
  mounted() {
    // this.getDefaultAddress()
    if (isWeixin()) {
      this.payWays = 3;
    }
    if (getOpenId()) {
      this.openId = getOpenId();
    }
  },
  methods: {
    // 获取商品详情
    getClubProductDetailById() {
      var that = this;
      var param = {
        service: "appagg",
        query: that.id,
      };
      this.$api.getClubProductDetailById(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.projectDetail = res.data.result;
            if (this.projectDetail) {
              this.sum = this.number * this.projectDetail.price;
              this.status = this.$route.query.status;
            }
          }
        }
      });
    },
    inputLength(e) {
      if (e.target.value.length > 4) {
        e.target.value = e.target.value.slice(0, 4);
      }
      // console.log(this.number,this.projectDetail.price,111)
      // if(this.number){
      //   console.log(this.number,this.projectDetail.price,222)
      //   this.sum = (this.number * this.projectDetail.price).toFixed(2);
      // }
    },
    blurInput() {
      if (!this.number) {
        this.number = 1;
        this.sum = (this.number * this.projectDetail.price).toFixed(2);
      }
      // this.sum = (this.number * this.projectDetail.price).toFixed(2);
    },
    // 获取默认地址
    getDefaultAddress() {
      var that = this;
      var param = {
        service: "appagg",
      };
      if (this.addressId) {
        param.query = {
          id: this.addressId,
        };
      } else {
        param.query = {};
      }

      this.$api.getSingleAddress(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            if (res.data.result) {
              this.defaultAddressInfo = res.data.result;
            }
          }
        }
      });
    },
    accelerate(type, item) {
      this.number = parseInt(this.number);
      if (type === 1) {
        // 减
        if (this.number >= 2) {
          this.number = this.number - 1;
        }
      } else if (type === 2) {
        // 加
        this.number = this.number + 1;
      }
      this.sum = (this.number * this.projectDetail.price).toFixed(2);
    },
    // 更新数量
    updateItemQuantity(goodsId, quantity) {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          goodsId: goodsId,
          quantity: quantity,
        },
      };
      this.$api.UpdateItemQuantity(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
          }
        }
      });
    },
    showActionSheet() {
      this.show = true;
    },
    linkPay() {
      var that = this;
      if (this.sum == 0) {
        this.$toast("价格为0的商品不能下单");
        return false;
      }
      if (this.isWx) {
        this.payWays = 3;
      }
      //   if (!this.payWays) {
      //     this.$toast("请选择支付方式");
      //     return false;
      //   }
      // 单个下单
      var param = {
        service: "appagg",
        query: {
          goodsId: this.projectDetail.id,
          quantity: this.number,
          paymentWay: this.payWays,
          businessId: this.businessId,
          orderType: 2,
        },
      };
      if (this.payWays == 3) {
        param.query.openId = this.openId;
      }
      console.log("isWx" + this.isWx);
      if (this.isWx) {
        this.goApplet();
      } else {
        that.$api.createOrder(param).then((res) => {
          if (res) {
            if (res.data.basis.status === 200) {
              console.log(
                res.data.result.parameters,
                res.data.result.order.paymentOrderId,
                111111
              );
              this.alipay(
                res.data.result.parameters,
                res.data.result.order.paymentOrderId
              );
            }
          }
        });
      }
    },
    // 下单在小程序端
    goApplet() {
      let that = this;
      let options = {
        token: getToken(),
        appletHasToken: () => {
          console.log("小程序跳转");
          if (that.from == 1) {
            console.log("进来了")
            let xcxUrl = `/pages/pay/pay?businessId=${that.businessId}&goodsId=${that.projectDetail.id}&quantity=${that.number}&orderType=2&paymentWay=${that.payWays}&from=1`;
            // setTimeout(()=>{
            // this.$route.meta.title="商品详情"
            // that.$router.replace({ path:'/goodDetails', query: { id: this.goodsList[0].items[0].goodsId} });

            // },1000)
            setTimeout(() => {
              that.$router.go(-1);
            }, 3500);
            wx.miniProgram.navigateTo({ url: xcxUrl });

            // that.$router.go(-1);
            console.log("appletHasToken-- 1  --");
            // that.$toast({
            //   duration: 3000,
            //   message: 'go11111'
            // });
          }
        },
        appletNoToken: () => {
          console.log("小程序跳转");
          if (that.from == 1) {
            console.log("进来了")
            let xcxUrl = `/pages/pay/pay?businessId=${that.businessId}&goodsId=${that.projectDetail.id}&quantity=${that.number}&orderType=2&paymentWay=${that.payWays}&from=1`;
            // setTimeout(()=>{
            // this.$route.meta.title="商品详情"
            // that.$router.replace({ path:'/goodDetails', query: { id: 49} });

            // },1000)
            wx.miniProgram.navigateTo({ url: xcxUrl });
            that.$router.go(-1);
            console.log("appletNoToken-- 1  --");
          }
        },
        weiXinHasToken: () => {},
        weiXinNoToken: () => {},
        iphoneHasToken: () => {},
        iphoneNoToken: () => {},
        androidHasToken: () => {},
        androidNoToken: () => {},
        browserHasToken: () => {},
        browserNoToken: () => {},
      };
      browserEnvironment(options);
    },
    alipay(payParameters, paymentOrderId) {
      let that = this;
      console.log(this.payWays, "payWays");
      let options = {
        token: getToken(),
        appletHasToken: () => {
          let xcxUrl = `/pages/pay/pay?paymentOrderId=${paymentOrderId}&payParameters=${payParameters}`;
          wx.miniProgram.navigateTo({ url: xcxUrl });
        },
        appletNoToken: () => {
          let xcxUrl = `/pages/pay/pay?paymentOrderId=${paymentOrderId}&payParameters=${payParameters}`;
          wx.miniProgram.navigateTo({ url: xcxUrl });
        },
        weiXinHasToken: () => {},
        weiXinNoToken: () => {},
        iphoneHasToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: paymentOrderId,
            payParameters: payParameters,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        iphoneNoToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: paymentOrderId,
            payParameters: payParameters,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidHasToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: paymentOrderId,
            payParameters: payParameters,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidNoToken: () => {
          let appParams = {
            payWays: this.payWays,
            paymentOrderId: paymentOrderId,
            payParameters: payParameters,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        browserHasToken: () => {},
        browserNoToken: () => {},
      };
      browserEnvironment(options);
    },
    chooseWays(payWays) {
      this.payWays = payWays;
    },
    chooseAddress() {
      this.$router.push({ path: "/addressManage", query: { from: this.from } });
    },
  },
  // activated () {
  //   debugger
  //   eventBus.$on('choiceAddressId', function (data) {
  //     this.addressId = data;
  //     this.getDefaultAddress()
  //   }.bind(this))
  // },
  // beforeRouteLeave(to, from, next) {
  //   // 设置下一个路由的meta
  //   to.meta.keepAlive = false // 不缓存，即刷新
  //   next()
  // },
  watch: {
    $route(to, from) {
      // debugger
      // if (from.fullPath.indexOf('addressManage') > -1) {
      //   var choiceAddressId = Cookies.get('choiceAddressId');
      //   if (choiceAddressId) {
      //     this.addressId = choiceAddressId;
      //     this.getDefaultAddress()
      //   }
      // }
      console.log("confirmOrder22222");
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(this, "beforeRouteEnter"); // undefined
    console.log(to, "组件独享守卫beforeRouteEnter第一个参数");
    console.log(from, "组件独享守卫beforeRouteEnter第二个参数");
    console.log(next, "组件独享守卫beforeRouteEnter第三个参数");
    next((vm) => {
      // 因为当钩子执行前，组件实例还没被创建
      // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      if (from.fullPath.indexOf("addressManage") > -1) {
        var choiceAddressId = Cookies.get("choiceAddressId");
        if (choiceAddressId) {
          vm.addressId = choiceAddressId;
          vm.getDefaultAddress();
        } else {
          vm.getDefaultAddress();
        }
        // eventBus.$on('choiceAddressId', function (data) {
        //   vm.addressId = data;
        //   vm.getDefaultAddress()
        // })
      } else {
        vm.getDefaultAddress();
      }
      // console.log(vm);// 当前组件的实例
    });
  },
};
</script>

  <style scoped lang="less">
.nameAndPhone {
  font-size: 30px;
}
.ocupie {
  height: 366px;
  width: 100%;
}
.paddingBorder {
  padding: 32px 0;
  border-bottom: 2px solid rgba(208, 214, 230, 0.3);
}
.pro_list li:last-child .paddingBorder {
  border: none;
}
.popTitle {
  color: #3e3e3e;
  font-size: 36px;
  text-align: center;
  font-weight: bold;
}
/deep/ .van-popup--bottom {
  border-radius: 12px 12px 0px 0px;
  min-height: 300px;
  padding: 32px 32px 0px;
  box-sizing: border-box;
}
.static {
  color: #3e3e3e;
  font-size: 24px;
  width: 152px;
  height: 148px;
  transform: translateX(32px);
  background: url("../../../assets/img/all_num_bg.png") no-repeat;
}
.morePro {
  width: 148px;
  height: 148px;
  margin-right: 32px;
  float: left;
}
.morePro:nth-child(3) {
  margin-right: 0;
}
.wayIcon {
  width: 50px;
  height: 50px;
  margin-right: 38px;
}
.ways {
  font-size: 32px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #3e3e3e;
  border-bottom: 2px solid rgba(208, 214, 230, 0.3);
  padding: 24px 0;
}
.payWay {
  position: fixed;
  bottom: 120px;
  left: 0;
  padding: 0 32px;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
}
.money {
  color: #ff3e29;
  font-size: 32px;
}
.allBox {
  padding: 60px 0;
  text-align: right;
  font-size: 28px;
  font-weight: bold;
  color: #3e3e3e;
}
.allBox > span {
  font-weight: bold;
}
.boxPart {
  padding: 22px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid rgba(208, 214, 230, 0.3);
  border-top: 2px solid rgba(208, 214, 230, 0.3);
  color: #3e3e3e;
  font-size: 28px;
}
.boxPart > div {
  font-weight: bold;
}
.select-box img {
  width: 38px;
  height: 38px;
  display: inline-block;
  vertical-align: middle;
}

.select-box {
  width: 38px;
  height: 38px;
  border-radius: 100%;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  -ms-border-radius: 100%;
  /*border: 1px solid #999;*/
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  display: inline-block;
  margin-right: 10px;
}
.commonBox {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 32px;
}
.priceDive {
  color: red;
}

.liDiv {
  display: flex;
  padding: 0 20px;
}
//.liDiv > div{
//  margin-bottom: 10px;
//  font-size: 32px;
//  display: flex;
//  padding: 10px 20px;
//  box-sizing: border-box;
//}

.goods-list {
  width: 100%;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  opacity: 1;
  border-radius: 12px;
  padding: 32px;
  box-sizing: border-box;
  margin-bottom: 32px;
}
.goods-list-static {
  width: 100%;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 32px;
}
.goods-list-static.noRadiu {
  border-radius: 0 0 12px 12px;
  box-shadow: 0px 0px 0px transparent;
}
.goods-list-static.noRadiu .boxPart {
  border-top: none;
}

.goods-list.noMargin {
  margin-bottom: 0px;
}
.goods-list.noRadiuShadow {
  border-radius: 12px 12px 0 0;
  box-shadow: 0px 0px 0px transparent;
}
.Box {
  display: flex;
  flex-direction: column;
}
.box {
  padding: 0 32px;
  min-height: 102px;
  font-size: 28px;
  font-weight: 400;
  color: #3e3e3e;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .blackSpan {
    font-weight: bold;
    color: #3c4041;
  }
  .yellowSpan {
    font-weight: bold;
    color: #ffaf46;
  }
}
.bottomBox {
  flex: 1;
  padding-left: 32px;
  padding-left: 26px;
  font-size: 28px;
  font-weight: 400;
  color: #3e3e3e;
  background-color: #fff;
  span {
    display: block;
    padding: 32px 0 16px;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #b1b1b2;
    line-height: 36px;
  }
}
.border2 {
  border-bottom: 2px solid rgba(208, 214, 230, 0.31);
}
.border8 {
  border-bottom: 8px solid rgba(208, 214, 230, 0.31);
}
.paddingRight0 {
  padding-right: 0;
}
.height120 {
  height: 120px;
  box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.16);
}
.slh {
  overflow: hidden; //溢出隐藏
  white-space: nowrap; //禁止换行
  text-overflow: ellipsis; //...
}
.body {
  height: 100%;
  background: #ffffff;
}
</style>
